<template>
  <SoftwareCenterModal
    :software="store.software"
    :open="open"
    :preferred-os="preferredOs"
    @close-modal="onAbort"
    @after-close-modal="onAfterClose"
  />
</template>

<script setup lang="ts">
import { useDownloadStore } from '~/stores/downloadStore/softwareDownloadStore';
import SoftwareCenterModal from './SoftwareCenterModal.vue';

const props = defineProps<{
  abortFunction?: () => void;
  afterCloseFunction?: () => void;
}>();

const store = useDownloadStore();

const onAbort = () => {
  if (props.abortFunction) {
    props.abortFunction();
  } else {
    store.closeModal();
  }
};

const onAfterClose = () => {
  if (props.afterCloseFunction) {
    props.afterCloseFunction();
  } else {
    store.afterCloseModal();
  }
};

const open = computed(
  () => store.activeModal === true || typeof store.activeModal === 'string'
);
const preferredOs = computed<string | undefined>(() => {
  const selectedOs = store.filters['groupAssets.supportedOs.data'];

  return selectedOs?.length === 1 ? selectedOs[0] : undefined;
});

watch(
  () => store.software,
  () => {
    if (store.software && store.activeModal === true) {
      store.activeModal = store.software.id;
    }
  }
);
</script>
